import React from 'react';
import './ConfirmationDialog.css';
import AlertIcon from '../../assets/svg/AlertIcon.svg';

const ConfirmationDialog = ({ onClose, onConfirm, type }) => {
    return (
        <>
            <div className="custom-overlay" onClick={onClose}></div>
            <div className="custom-modal-container">
                <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="custom-modal-content">
                        <div className="custom-header">
                            <img src={AlertIcon} alt="Alert Icon" />
                            {type === "install" && <div className="custom-text">
                                <h2 className="custom-title">
                                    Canceling will stop package installation and use of the app in Salesforce
                                </h2>
                                <p className="custom-description">
                                    Are you sure you want to cancel installation?
                                </p>
                            </div>}
                            {type === "upgrade" && <div className="custom-text">
                                <h2 className="custom-title">
                                    Canceling will stop installing the packages
                                </h2>
                                <p className="custom-description">
                                    Are you sure you want to cancel installation?
                                </p>
                            </div>}
                        </div>
                        <div className="custom-actions">
                            <button
                                onClick={onClose}
                                className="custom-btn custom-btn-secondary"
                                style={{ border: "none" }}
                            >
                                No, don't cancel
                            </button>
                            <button
                                onClick={onConfirm}
                                className="custom-btn custom-btn-primary"
                            >
                                Yes, Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ConfirmationDialog